import { shallowEqual } from 'react-redux'
import { is, isImmutable } from 'immutable'

export const isSame = (a, b) => {
  if (isImmutable(a) && isImmutable(b)) {
    return is(a, b)
  } else {
    return shallowEqual(a, b)
  }
}
